import { useState, useEffect } from 'react';

const ResponsiveTutorialIframe = ({ src }) => {
	const [dims, setDims] = useState({ width: 900, height: 580 });

	useEffect(() => {
		const updateSize = () => {
			const w = window.innerWidth;
			let width, height;

			if (w >= 1500) {
				width = 1200;
				height = 725;
			} else if (w >= 1400) {
				width = 1200;
				height = 700;
			} else if (w >= 1280) {
				width = 1150;
				height = 700;
			} else if (w >= 1024) {
				width = 900;
				height = 580;
			} else if (w >= 768) {
				width = 700;
				height = 450;
			} else if (w >= 425) {
				width = 350;
				height = 350;
			} else if (w >= 325) {
				width = 325;
				height = 350;
			} else {
				// pantallas más pequeñas: 100% del viewport menos un pequeño margen
				width = w - 20;
				// mantenemos la proporción original (900×580)
				height = Math.round((width * 580) / 900);
			}

			setDims({ width, height });
		};

		updateSize();
		window.addEventListener('resize', updateSize);
		return () => window.removeEventListener('resize', updateSize);
	}, []);

	return (
		<iframe
			src={src}
			width={dims.width}
			height={dims.height}
			// frameBorder='0'
			// allow='autoplay; fullscreen; picture-in-picture'
			// allowFullScreen
			title='Aquinas Online Library - ENG'
		/>
	);
};

export default ResponsiveTutorialIframe;
